module.exports = __webpack_public_path__ + "static/media/blue-cal.81c2ae7c.svg";